// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomSelect_icon__1y-de","icon-reverse":"CustomSelect_icon-reverse__2eRqV"};